import { fk, attr } from 'redux-orm'
import Base from './Base'

class Employment extends Base {
  static get fields() {
    return {
      id: attr(),
      employmentType: attr(),
      photoUrl: attr(),
      current: attr(),
      userId: fk({ to: 'user', as: 'user', relatedName: 'employments'}),
    }
  }
}

Employment.modelName = 'employment'

export default Employment;
